import React from 'react';
import { List, Datagrid, TextField, EmailField, DateField, FunctionField } from 'react-admin';
import { Chip } from '@mui/material';
import { AdminPanelSettings, Person } from '@mui/icons-material';

const UserList = (props) => (
  <List {...props} title="Gestion des Utilisateurs">
    <Datagrid>
      <TextField source="firstName" label="Prénom" />
      <TextField source="lastName" label="Nom" />
      <EmailField source="email" label="Email" />
      <FunctionField
        label="Rôle"
        render={(record) => (
          <Chip
            icon={record.role === 'admin' ? <AdminPanelSettings /> : <Person />}
            label={record.role === 'admin' ? 'Administrateur' : 'Client'}
            color={record.role === 'admin' ? 'error' : 'success'}
            size="small"
            variant="outlined"
          />
        )}
      />
      <DateField source="createdAt" label="Inscrit le" showTime />
    </Datagrid>
  </List>
);

export default UserList;
